import { memo, useEffect, useRef } from "react";
import { selectUserInfo } from "../../../../features/Auth/redux/selectors";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppNavLink } from "../../../../shared/components/AppNavLink";
import { useHeaderNavLinks } from "../../hooks/use-header-nav-links";
import logo from "../../../../shared/assets/img/logo.png";
import { selectVisibleLinks } from "../../redux/selectors";
import { AppButton } from "../../../../shared/components/AppButton";
import { TPopoverIds } from "../../../../app/state/popoverSlice/types";
import { TEntityInfo } from "../../../types/utility";
import { DotsIcon } from "../../../../shared/icons/DotsIcon";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { updatePopoverPosition } from "../../../../app/state/popoverSlice/slice";
import styles from "./styles.module.css";

interface Props {
  openPopover: (
    e: React.MouseEvent,
    id: TPopoverIds,
    info: TEntityInfo | null,
  ) => void;
}

const HeaderNavigationInner = ({ openPopover }: Props) => {
  const dispatch = useAppDispatch();
  const links = useAppSelector(selectVisibleLinks);
  const userInfo = useAppSelector(selectUserInfo);
  const headerNuvLinks = useHeaderNavLinks(links);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  useEffect(() => {
    const rect = buttonRef.current!.getBoundingClientRect();
    dispatch(
      updatePopoverPosition({
        id: "header_service_manager_popover",
        position: { x: rect.x, y: rect.y },
      }),
    );
  }, [headerNuvLinks?.length]);

  return (
    <div className={styles["nav-container"]}>
      <img className={styles.logo} src={logo} alt="logo" />

      <>
        {headerNuvLinks.map((route) => {
          const groups = userInfo?.["user-groups"];
          if (groups?.includes(route.path)) {
            return (
              <AppNavLink
                key={route.path}
                activeClassName={styles.active}
                className={styles["header-link"]}
                to={route.path}
              >
                {route.title}
              </AppNavLink>
            );
          }
        })}
      </>
      <AppButton
        ref={buttonRef}
        buttonType={"text"}
        onClick={(e) => openPopover(e, "header_service_manager_popover", null)}
        className={styles["nav-menu-button"]}
      >
        <DotsIcon className={styles["dots-icon"]} />
      </AppButton>
    </div>
  );
};

export const HeaderNavigation = memo(HeaderNavigationInner);
